import {Selector} from '@ngxs/store';
import {AdvertiserFavoriteDevicesState} from './advertiser-favorite-devices.state';
import {AdvertiserFavoriteDevicesModel} from './advertiser-favorite-devices.model';
import {IResponse} from '@interfaces/response';
import {IDeviceAdvertiser} from '@interfaces/advertiser/devices';
import {LatLngBounds} from 'leaflet';


export class AdvertiserFavoriteDevicesSelectors {
  @Selector([AdvertiserFavoriteDevicesState])
  static getAdvertiserFavoriteDevices(state: AdvertiserFavoriteDevicesModel): IResponse<IDeviceAdvertiser> | null {
    return state.devices;
  }

  @Selector([AdvertiserFavoriteDevicesState])
  static getAdvertiserFavoriteDevicesBounds(state: AdvertiserFavoriteDevicesModel): LatLngBounds | null {
    return state.mapBounds;
  }

  @Selector([AdvertiserFavoriteDevicesState])
  static getAdvertiserFavoriteDevicesSearch(state: AdvertiserFavoriteDevicesModel): string {
    return state.searchParam;
  }

  @Selector([AdvertiserFavoriteDevicesState])
  static getAdvertiserFavoriteDevicesCurrentPage(state: AdvertiserFavoriteDevicesModel): number {
    return state.deviceConfigList.currentPage;
  }

  @Selector([AdvertiserFavoriteDevicesState])
  static getAdvertiserFavoriteDevicesPerPage(state: AdvertiserFavoriteDevicesModel): number {
    return state.deviceConfigList.itemsPerPage;
  }

  @Selector([AdvertiserFavoriteDevicesState])
  static getAdvertiserFavoriteDevicesLoader(state: AdvertiserFavoriteDevicesModel): boolean {
    return state.deviceConfigList.loader;
  }
}
